import { debuglogger } from "./debugLogger";
export const setAnalytics = (config) => {
  if (config.ConfigKey) {
    const analyticsScript = document.getElementById("analyticsID");
    if (analyticsScript) {
      analyticsScript.remove();
    }
    var script = document.createElement("script");
    script.crossOrigin = "anonymous";
    let srcVal = "/js/analytics.js?configKey=" + config.ConfigKey;
    if (srcVal.match(/^[a-zA-Z0-9=_.?"\/]*$/) !== null) {
      script.src = srcVal;
    }
    script.type = "text/javascript";
    script.id = "analyticsID";
    script.setAttribute("data-test", "test");
    document.body.appendChild(script);
    debuglogger("UseEffect Check CustomerContactId", config?.customerContactID);
  }
};

//Initiate AdobeAnalytics
export const initiateAdobeAnalytics = () => {
  //var loaded = document.querySelector('script[src="https://static1.st8fm.com/en_US/applications/b2c/js/lib/launchtms_min.js"]') ;
  var id = "analyticsScriptId";
  if (document.getElementById(id) === null) {
    var analyticsScript = document.createElement("script");
    analyticsScript.crossOrigin = "anonymous";
    analyticsScript.src =
      "https://static1.st8fm.com/en_US/applications/b2c/js/lib/launchtms_min.js";
    analyticsScript.type = "text/javascript";
    analyticsScript.id = id;
    document.head.appendChild(analyticsScript);
    debuglogger("Adobe analytics script loaded");
  } else {
    setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent("chatOpenEventAA", {
          detail: { status: "OPEN" },
        })
      );
    }, 500);
  }
};
